import React from 'react';
import Pic1 from '../../InstallImages/Modules/SOLARIA360';


const moduleLink = <a href="https://www.dropbox.com/s/arow0xvq6n849ze/Solaria_360%20spec.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                Achieving up to 20% efficiency, Solaria PowerXT solar modules are one of the highest power modules in the residential solar market.Compared to conventional modules, Solaria PowerXT modules have fewer gaps between the solar cells; this leads to higher power and superior aesthetics. Solaria PowerXT residential modules are manufactured with black backsheet and frames, giving them a striking appearance.
            </p>
            <p className="specsText">
                Developed in California, Solaria’s patented cell cutting and module assembly takes processed solar wafers and turns them into PowerXT solar modules. The process starts by creating a highly reliable PowerXT cell where busbars and ribbon interconnections are eliminated. Solaria then packages the cells into the PowerXT solar module, reducing inactive space between the cells. All of the above leads to an exceptionally efficient solar module produced in a cost effective manner.
            </p>
            <ul> <h1>Key Features</h1>
                <li className="specsText">All Black</li>
                <li className="specsText">Higher Efficiency and Power - Solaria PowerXT modules achieve over 20% efficiency; conventional modules achieve 15%-17% efficiency. Solaria PowerXT modules are one of the highest power modules available. Solder-less cells interconnections are highly reliable and designed to far exceed the industry leading 25 year warranty.</li>
                <li className="specsText">Lower System Costs - Solaria PowerXT modules produce more power per square meter area. This reduces installation costs due to fewer balance of systems components.</li>
                <li className="specsText">Improved Shading Tolerance and Aesthetics - Sub-strings are interconnected in parallel, within each of four module quadrants, which dramatically lowers the shading losses and boosts energy yield. Compared to conventional modules, Solaria PowerXT modules have more uniform appearance and superior aesthetics.
                </li>
                <li className="specsText">{moduleLink}</li>
            </ul>
        </div>
    </div>
);


export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/solaria360.js